module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Volume-half-ed23d6d88c0063b674c9491fd6d891f2.svg";